import * as React from 'react';
import { connect } from 'react-redux';
import { Spinner } from '../common/Spinner';
import { Article } from '../contentful/contentfulClient';
import './Articles.css';
import { StoreState } from '../store/StoreState';
import { ArticleView } from './ArticleView';

interface ArticlesProps {
    articles: Array<Article>;
    loaded: boolean;
}

export const Articles: React.FC<ArticlesProps> = ({articles, loaded}) => (
    <div className="articles">
        <Spinner hide={loaded}/>
        {articles.map(article => <ArticleView key={article.id} article={article}/>)}
    </div>
);

Articles.defaultProps = {
    articles: []
};

const mapStateToProps: (state: StoreState) => ArticlesProps = state => (
    {
        articles: state.articles.list,
        loaded: state.articles.loaded,
    }
);

export default connect(mapStateToProps, null)(Articles);



// WEBPACK FOOTER //
// ./src/article/Articles.tsx